import { render, staticRenderFns } from "./FormTextAreaSize.vue?vue&type=template&id=ec0bc5ee&"
import script from "./FormTextAreaSize.vue?vue&type=script&lang=js&"
export * from "./FormTextAreaSize.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports